"use client";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import useClientTranslation from "@/hooks/useClientTranslation";

interface DeleteTokenModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  tokenName: string;
}

export default function DeleteTokenModal({
  open,
  onClose,
  onConfirm,
  tokenName,
}: DeleteTokenModalProps) {
  const { t } = useClientTranslation("tokenpg");

  const handleConfirm = async () => {
    await onConfirm();
    onClose();
  };

  return (
    <AlertDialog open={open} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("deleteModal.title")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("deleteModal.confirmMessage")} <span className="font-semibold text-foreground">{tokenName}</span> {t("deleteModal.confirmSuffix")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="flex gap-3 justify-end">
          <AlertDialogCancel>{t("deleteModal.cancel")}</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {t("deleteModal.confirm")}
          </AlertDialogAction>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}
